
import api from "@/api";
import DateComponent from "@/components/DateComponent.vue";
import DialogTableSubstr from "@/components/DialogTableSubstr.vue";
import ShowPopup from "@/components/ShowPopup.vue";
import { IRetencaoFinanceira } from "@/interfaces/retencao_financeira_cobranca";
import {
  cobrancaStore,
  companyStore,
  juridicoStore,
  mainStore,
  retencaoFinanceiraStore,
  userActionStore
} from "@/store";
import CreateCobrancaJudicial from "@/views/main/juridico/CreateCobrancaJudicial.vue";
import { differenceInDays, format, isEqual } from "date-fns";
import _ from "lodash";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Ocorrencia from "../cobranca/ocorrencia/Ocorrencia.vue";
import Financeiro from "./Financeiro.vue";
import UploadFilesRetencao from "./UploadFilesRetencao.vue";

@Component({
  components: {
    ShowPopup,
    DateComponent,
    DialogTableSubstr,
    Financeiro,
    ValidationProvider,
    ValidationObserver,
    UploadFilesRetencao,
    CreateCobrancaJudicial,
    Ocorrencia,
  },
})
export default class ListFinanceiro extends Vue {
  @Prop({ type: Number }) readonly propId;
  @Prop({ type: String, default: "" }) readonly propTipoTitulo;
  @Prop({
    type: Object,
    default: () => {},
  })
  readonly propRetencaoItem;
  @Watch("tiposFatura", { immediate: true, deep: true })
  async onChangeC014_id(val: number) {
    this.selected = [];
    this.titulosSerasa = await juridicoStore.getTitulosSerasa(
      this.propRetencaoItem.c014_id
    );
    this.titulosCobrancaJudicial = await juridicoStore.getTitulosCobranca(
      this.propRetencaoItem.c014_id
    );
    this.buscaTituloItems();
  }

  @Watch("dataRangeFinanceiro", {immediate: true, deep: true})
  async onChangeDateRange(){

    if((this.dataRangeFinanceiro && this.dataRangeFinanceiro.length >= 2) || this.dataRangeFinanceiro === null){
      this.selected = [];
      this.buscaTituloItems();
    }

  }

  @Watch("propState", { immediate: true, deep: true })
  async reloadOcorrencias() {
    if (this.propState > 0) {
      await this.load();
      if (this.propRetencaoItem.c014_id > 0) {
        this.unidadeDetails = await companyStore.getCompanyByC014_id(
          String(this.propRetencaoItem.c014_id)
        );
      }
      this.selected = [];
      this.titulosSerasa = await juridicoStore.getTitulosSerasa(
        this.propRetencaoItem.c014_id
      );
      this.titulosCobrancaJudicial = await juridicoStore.getTitulosCobranca(
        this.propRetencaoItem.c014_id
      );
      this.buscaTituloItems();
      this.ocorrenciaItems = await retencaoFinanceiraStore.getRetencaoFinanceiraCobranca(
        this.propRetencaoItem.c014_id
      );
    }
  }

  @Watch("tiposTitulo", { immediate: true, deep: true })
  async getTitulos() {
    if (this.tiposTitulo.length > 0) {
      this.buscaTituloItems();

      if (this.tiposTitulo) {
        await this.load();
        if (this.propRetencaoItem.c014_id > 0) {
          this.unidadeDetails = await companyStore.getCompanyByC014_id(
            String(this.propRetencaoItem.c014_id)
          );
        }
        this.selected = [];
        this.titulosSerasa = await juridicoStore.getTitulosSerasa(
          this.propRetencaoItem.c014_id
        );
        this.titulosCobrancaJudicial = await juridicoStore.getTitulosCobranca(
          this.propRetencaoItem.c014_id
        );
        // this.buscaTituloItems();
        this.ocorrenciaItems = await retencaoFinanceiraStore.getRetencaoFinanceiraCobranca(
          this.propRetencaoItem.c014_id
        );
      }
    }
  }

  public tiposTitulo = [];
  public isLoadingTitulos = false;
  public unidadeDetails = null;
  public titulosSerasa = "";
  public tituloSerasaPago = "";
  public motivoNaoPagamento = [];
  public titulosCobrancaJudicial = "";
  public tituloJudicialPago = "";
  public etapaCobranca = "";
  public propTitulos = [];
  public tituloItems = [];
  public propTitle = "";
  public propTitleBtn = "";
  public propTituloAlert = "";
  public propTipo = "";
  public hoje = format(new Date(), "yyyy-MM-dd");

  public acaoExecutada = [];
  public titulosOptions: any[] = [];
  public selectedTitulos: string[] = [];

  public selected = [];

  public dataRangeFinanceiro = null;
  public isDownloading = false;

  public tipoContato = "";
  public descricaoOcorrencia = "";
  public dataProximaCobranca = "";
  public objetivoCobranca = "";

  public tipoAcoesItems = [];
  public isLoading = false;
  public isSubmit = false;
  public cobrancaItems = [];
  public ocorrenciaItems = [];

  public ocorrencia_files = [];
  public propState = 0;

  public departamentoAux = 0;
  public nextDepartamentoAux = 0;

  public statusAux = 0;
  public tableId = 0;
  public tableName = "";
  public created_by_id = 0;

  public idOcorrencia = 0;
  public company_c014id = 0;
  public tipoTitulo = 0;

  public descricao = "";

  public atendidoDepartamento = 0;
  public proximoDepartamento = 0;
  public proximoStatus = 0;
  public departamentos_do_tipo = [];
  public departamentos_do_tipo2 = [];

  public tiposFatura = "emAberto";

  public totalDevido = 0;
  public qtdTitulosVencidos = 0;
  public c014_id = 0;
  public search = "";

  public headerOcorrencia = [
    {
      text: "Títulos",
      sortable: false,
      value: "titulo",
      align: "left",
      maxWidth: 200,
    },
    {
      text: "Tipo do Contato",
      sortable: false,
      value: "tipo_contato",
      align: "left",
    },
    {
      text: "Motivo não pagamento",
      sortable: false,
      value: "motivo_nao_pagamento",
      align: "left",
    },
    {
      text: "Etapa da Cobrança",
      sortable: false,
      value: "etapa_cobranca",
      align: "left",
    },
    {
      text: "Ação Executada",
      sortable: false,
      value: "acao_executada",
      align: "left",
    },
    {
      text: "Data da Próxima Cobrança",
      sortable: false,
      value: "proximo_contato",
      align: "left",
    },
    {
      text: "Descrição",
      width: 400,
      sortable: false,
      value: "descricao",
      align: "left",
    },
    {
      text: "Objetivo",
      sortable: false,
      value: "objetivo",
      align: "center",
    },
    {
      text: "Status",
      sortable: false,
      value: "descricao_status",
      align: "left",
    },
    {
      text: "Criado Por",
      sortable: false,
      value: "created_by_name",
      align: "Left",
    },
    {
      text: "Data",
      sortable: false,
      value: "created_at",
      align: "Left",
    },

    {
      text: "Ações",
      sortable: false,
      value: "actions",
      align: "center",
    },
  ];

  public today = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

  // header do financeiro unidade
  public headers = [
    {
      text: "Nº Título",
      sortable: true,
      value: "Documento",
      align: "left",
    },
    {
      text: "Vencimento",
      sortable: true,
      value: "T014_Vencimento",
      align: "left",
    },
    {
      text: "Tipo",
      sortable: true,
      value: "Tipo",
      align: "left",
    },
    {
      text: "Tipo Baixa",
      sortable: true,
      value: "descricao",
      align: "left",
    },
    {
      text: "Valor original",
      sortable: true,
      value: "valor_original",
      align: "left",
    },
    {
      text: "Valor atualizado",
      sortable: true,
      value: "valor_atualizado",
      align: "left",
    },
  ];

  // header do financeiro unidade
  public headersFinanceiro = [
    {
      text: "Nº Título",
      sortable: true,
      value: "Documento",
      align: "left",
    },
    {
      text: "Vencimento",
      sortable: true,
      value: "T014_Vencimento",
      align: "left",
    },
    {
      text: "Data pagamento",
      sortable: true,
      value: "T014_DataPagamento",
      align: "left",
    },
    {
      text: "Tipo",
      sortable: true,
      value: "Tipo",
      align: "left",
    },
    {
      text: "Tipo Baixa",
      sortable: true,
      value: "descricao",
      align: "left",
    },
    {
      text: "Valor original",
      sortable: true,
      value: "valor_original",
      align: "left",
    },
    {
      text: "Valor atualizado",
      sortable: true,
      value: "valor_atualizado",
      align: "left",
    },
    {
      text: "Dias Atraso",
      sortable: true,
      value: "Atraso",
      align: "left",
    },
    {
      text: "Serasa",
      sortable: true,
      value: "status_serasa",
      align: "left",
    },
    {
      text: "Cobrança Judicial",
      sortable: true,
      value: "status_judicial",
      align: "left",
    },
    {
      text: "Baixar Boleto",
      value: "baixar_boleto",
      align: "center",
    },
    {
      text: "Copiar Código",
      value: "copiar_codigo",
      align: "center",
    },
  ];

  get itemsTipoTitulo() {
    return [
      {
        id: 1,
        descricao: "Livro",
      },
      {
        id: 2,
        descricao: "Renegociação",
      },
      {
        id: 3,
        descricao: "Mutuo",
      },
      {
        id: 4,
        descricao: "Fundo",
      },
      {
        id: 5,
        descricao: "Taxa de franquia",
      },
      {
        id: 6,
        descricao: "Reembolso",
      },
    ];
  }

  get details() {
    return cobrancaStore.cobrancaDetails;
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  get getHeader() {
    if (!this.userProfile) return;

    // if (this.userProfile.is_superuser || this.userProfile.departure_id === 11) {
    this.load();
    return this.headersFinanceiro;
    // }
    // return this.headers;
  }

  get titulosAll() {
    let item = this.tituloItems;

    // item = item.filter((f) => f.data_vencimento === "vencido");

    return item;
  }

  get totalValorSelecionado() {
    let contador = 0;
    let valor = 0;
    let valor_atualizado = 0;
    if (this.selected) {
      this.selected.map((item) => {
        valor += item.valor_original;
        valor_atualizado += item.valor_atualizado;
        contador += 1;
      });
    }
    return [valor, valor_atualizado, contador];
  }

  get titulosEmAberto() {
    let item = this.tituloItems;

    item = item.filter((f) => f.data_vencimento === "vencido");

    return item;
  }

  // get tituloItems() {
  public async buscaTituloItems() {
    let array = [];
    let titulosVencidos = [];
    this.tituloItems = [];

    this.isLoadingTitulos = true;

    //@ts-ignore
    if (!this.details.titulos) return array;

    this.qtdTitulosVencidos = 0;

    //@ts-ignore
    for (const a in this.details.titulos) {
      if (this.tiposFatura === "emAberto") {
        //@ts-ignore
        const item = this.details.titulos[a];

        item["data_vencimento"] = "";
        if (
          item.valor_original &&
          !item.valor_atualizado &&
          item.valor_original !== item.valor_pago
        ) {
          //@ts-ignore
          array.push(item);
        } else if (
          !item.valor_pago ||
          (item["valor_atualizado"] &&
            item["valor_pago"] &&
            item.valor_atualizado > 0)
        ) {
          //item['valor_atualizado'] && item['valor_pago']"
          if (new Date(item.T014_Vencimento) < this.today) {
            if (isEqual(new Date(item.T014_Vencimento), this.today)) {
              item["valor_atualizado"] = item.valor_original;
            }
            item["data_vencimento"] = "vencido";
            var date1 = new Date(item.T014_Vencimento);
            var dias = differenceInDays(this.today, date1);
            item["Atraso"] = dias;

            this.qtdTitulosVencidos += 1;
            //@ts-ignore
            titulosVencidos.push(item);
          }

          if (this.titulosSerasa[0].includes(item.Documento)) {
            this.tituloSerasaPago = item.Documento;
            item["status_serasa"] = "Serasa";
            item["titulo_serasa"] = this.getTituloSerasaPago();
            // item["selectable"] = false;
          } else {
            item["status_serasa"] = "";
            item["titulo_serasa"] = "";
            //   item["selectable"] = true;
          }

          if (this.titulosCobrancaJudicial[0].includes(item.Documento)) {
            this.tituloJudicialPago = item.Documento;
            item["status_judicial"] = "Cobrança Judicial";
            item["titulo_judicial"] = this.getTituloJudicialPago();
            // item["selectable"] = false;
          } else {
            item["status_judicial"] = "";
            item["titulo_judicial"] = "";
            //   item["selectable"] = true;
          }

          item["selectable"] = true;

          //@ts-ignore
          array.push(item);
        }
      } else {
        //@ts-ignore
        const item = this.details.titulos[a];

        item["data_vencimento"] = "";

        if (item.valor_pago >= item["valor_original"]) {
          if (new Date(item.T014_Vencimento) < this.today) {
            item["data_vencimento"] = "";
          }

          if (this.titulosSerasa[0].includes(item.Documento)) {
            this.tituloSerasaPago = item.Documento;
            item["status_serasa"] = "Serasa";
            item["titulo_serasa"] = this.getTituloSerasaPago();
          } else {
            item["status_serasa"] = "";
            item["titulo_serasa"] = "";
          }

          if (this.titulosCobrancaJudicial[0].includes(item.Documento)) {
            this.tituloJudicialPago = item.Documento;
            item["status_judicial"] = "Cobrança Judicial";
            item["titulo_judicial"] = this.getTituloJudicialPago();
          } else {
            item["status_judicial"] = "";
            item["titulo_judicial"] = "";
          }

          item["selectable"] = true;
          //@ts-ignore
          array.push(item);
        }
      }
    }

    if(!userActionStore.VisualizarTitulosBloqueados || userActionStore.VisualizarTitulosBloqueados == null){
      array = _.filter(array, (obj) => {
        return !obj['t014_bloqueado']
      })
    }

    // Filtra somente os titulos no range do filtro de data de vencimento entre
    if(this.dataRangeFinanceiro && this.dataRangeFinanceiro.length >= 2){
      let dataInicio = new Date(this.dataRangeFinanceiro[0])
      let dataFim = new Date(this.dataRangeFinanceiro[1])
      array = _.filter(array, (obj) => {
          let dataVencimento = new Date(obj['T014_Vencimento']);
          return dataVencimento >= dataInicio && dataVencimento <= dataFim;
      })
    }
    // SOMA VALOR TOTAL DEVIDO E ATRASADO
    this.totalDevido = _.sum(
      _.map(titulosVencidos, (t) => _.toNumber(t.valor_atualizado))
    )

    if (this.tiposFatura === "emAberto") {
      this.tituloItems = _.orderBy(array, ["T014_Vencimento"], ["asc"]);
    } else {
      this.tituloItems = _.orderBy(array, ["T014_Vencimento"], ["desc"]);
    }

    this.isLoadingTitulos = false;

    let item = this.tituloItems;
    if (this.tiposTitulo) {
      const ids = _.map(this.tiposTitulo, (item) => item.descricao);
      if (ids.length > 0) {
        item = item.filter((f) => ids.includes(f.Tipo));
        this.tituloItems = item;

        return this.tituloItems;
      }
    } else {
      return this.tituloItems;
    }
  }

  public async baixarExcel() {
    try {
      // requisição POST para a rota do backend que gera o arquivo Excel
      let items = this.selected
      const response = await api.getExcelTitulosFinanceiro(mainStore.token, items);
      if(response){
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Criando um elemento de link para simular o clique e iniciar o download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "titulos.xlsx");
        document.body.appendChild(link);
        link.click();

        setTimeout(async () => {
            window.URL.revokeObjectURL(url);
        }, 100);
          // Liberando os recursos
      }
        // Criando um link para fazer o download do arquivo
    } catch (error) {
      await mainStore.checkApiError(<any>error)
    }
  }

  public async baixarPdf() {
    try {
      // requisição POST para a rota do backend que gera o arquivo Pdf
      let items = this.selected
      this.isDownloading = true;
      const response = await api.getPdfTitulosFinanceiro(mainStore.token, items);
      if(response){
        let mywindow = window.open(
          "_blank",
          "scrollbars=yes, resizable=no, height=600,width=700,top=100,left=150"
        );
        //@ts-ignore
        mywindow.document.write(response.data);
        //@ts-ignore
        mywindow.document.close(); // necessary for IE >= 10
        //@ts-ignore
        mywindow.focus(); // necessary for IE >= 10*/
      }
      this.isDownloading = false;
    } catch (error) {
      this.isDownloading = false;
      await mainStore.checkApiError(<any>error)
    }
  }

  public async baixarBoleto(item) {
    try {
      const response = await api.getCompanyBoletos(mainStore.token, item);
      if (response) {
        const bytes = response.data;

        const blob = new Blob([bytes], { type: "application/pdf" });
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", `${item.Documento}.pdf`);
        if (typeof tempLink.download === "undefined") {
          tempLink.setAttribute("target", "_blank");
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setTimeout(() => {
          window.URL.revokeObjectURL(blobURL);
        }, 100);
      }
    } catch (e) {
      await mainStore.checkApiError(<any>e);
    }
  }

  public async getCodigoBoleto(id) {
    const loadingNotification = { content: "Copiando", showProgress: true };
    try {
      mainStore.addNotification(loadingNotification);
      const response = await api.getCodigoBoleto(mainStore.token, id);
      if (response) {
        navigator.clipboard.writeText(response.data);
        mainStore.removeNotification(loadingNotification);
        mainStore.addNotification({
          content: "Código copiado com sucesso",
          color: "success",
        });
      }
    } catch (error) {
      mainStore.removeNotification(loadingNotification);
      mainStore.addNotification({
        content: "Ocorreu um erro ao copiar o código",
        color: "error",
      });
      await mainStore.checkApiError(<any>error);
    }
  }

  public async handleSendSerasa() {
    this.propTitulos = this.selected;
    this.propTitle = "Solicitar envio de títulos para o Serasa";
    this.propTitleBtn = "Solicitar Envio para o Serasa";
    this.propTituloAlert = "Serasa";
    this.propTipo = "S";
    this.propState = 0;
    let form: any = null;
    form = this.$refs.sendCob;
    form.show();
  }

  public async handleSendCobranca() {
    this.propTitulos = this.selected;
    this.propTitle = "Solicitar envio de títulos para Cobrança Judicial";
    this.propTitleBtn = "Solicitar envio para Cobrança judicial";
    this.propTituloAlert = "Cobrança Judicial";
    this.propTipo = "C";
    this.propState = 0;
    let form: any = null;
    form = this.$refs.sendCob;
    form.show();
  }

  public titleCase(txt: string) {
    return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
  }

  get statusSolicitacao() {
    return [
      {
        id: 1,
        descricao: "Em atendimento",
      },
      {
        id: 2,
        descricao: "Concluído",
      },
    ];
  }

  // get franqueados() {
  //   //@ts-ignore
  //   return this.unidadeDetails.suporte.filter((item) => {
  //     if (item.cargo == "FRANQUEADO") {
  //       return item;
  //     }
  //   });
  // }
  get objetivoItems() {
    return ["Objetivo atingido", "Objetivo não atingido"];
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  get etapaCobrancaOptions() {
    return _.sortBy([
      "1º Cobrança",
      "2º Cobrança",
      "3º Cobrança",
      "4º Cobrança",
      "5º Cobrança",
      "Cobrança",
      "Alteração de vencimento",
      "Associação gestora fundo de propaganda",
      "Cadastro",
      "Convenção",
      "Financeiro",
      "Jurídico",
      "Negociação de pedidos",
      "Pedido",
      "Tentativa de contato",
      "Trocas",
      "Contas a pagar",
      "Retenção Financeira"
    ]);
  }

  get motivoNaoPagamentoOptions() {
    return _.sortBy([
      "Esqueceu de pagar",
      "Esta contratando funcionário novo",
      "Não está fazendo matrícula",
      "Não está no ponto de equilibrio",
      "Não recebeu livro de aluno",
      "Não tinha o valor total",
      "Pagou contas da escola",
      "Pandemia",
      "Pediu Distrato",
      "Problemas na inaguração",
      "Problemas no mutuo",
      "Sem dinheiro",
      "Ocorrência - Baixa não realizada",
      "Alteração de vencimento não realizada",
      "Negociação não lançada",
      "Erro de separação",
      "Erro de transportadora",
      "Cancelamento de pedido requisitado",
      "Problema de envio",
      "Escola fechou",
    ]);
  }

  get acaoExecutadaOptions() {
    return _.sortBy([
      "Pedido liberado",
      "Pagamento agendado",
      "Em negociação",
      "Protestar",
      "Enviado para ouvidoria",
      "Alterada condição pgto para somente a vista",
      "Alterada condição pgto para somente antecipado",
      "Liberado parcelamento",
      "Pagamento efetuado",
      "Negociado",
      "Retirar protesto",
      "Confissao de dividas",
      "Pedido cancelado",
    ]);
  }

  public handleUploadFile(item: any) {
    this.tableId = item.id;
    this.tableName =
      String(this.propRetencaoItem.c014_id) + "retencao_financeira";
    this.created_by_id = item.created_by_id;
    let form: any = this.$refs.showFiles;
    form.show();
  }

  public handleListCobranca() {
    let form: any = this.$refs.showCobranca;
    form.show();
  }

  public async handleAdicionarOcorrencia() {
    this.$swal({
      title: "Confirma salvar a cobrança?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, eu confirmo!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isSubmit = true;

        if (typeof this.proximoStatus == "object") {
          //@ts-ignore
          this.statusAux = this.proximoStatus.id;
        } else {
          this.statusAux = Number(this.proximoStatus);
        }

        let t014_id_parcela = "";
        let titulos = "";

        const estaVazio = this.selectedTitulos.some((item) =>
          isNaN(Number(item))
        );

        if (!estaVazio && this.selectedTitulos.length > 0) {
          t014_id_parcela = this.selectedTitulos.join(",");
          titulos = await retencaoFinanceiraStore.getDocumentos_By_t014_id_parcela(
            t014_id_parcela
          );
        }
        let motivos = this.motivoNaoPagamento.join(",");
        let acoes = this.acaoExecutada.join(",");

        const ocorrencia: IRetencaoFinanceira = {
          company_id: this.propRetencaoItem.companyId,
          c014_id: this.propRetencaoItem.c014_id,
          descricao: this.descricao,
          titulo: titulos,
          t014_id_parcela: t014_id_parcela,
          tipo_contato: this.tipoContato,
          motivo_nao_pagamento: motivos,
          etapa_cobranca: this.etapaCobranca,
          acao_executada: acoes,
          proximo_contato: this.dataProximaCobranca,
          objetivo: this.objetivoCobranca,
          status: this.statusAux,
          created_by_id: this.currentUser.id,
          created_by_name: this.currentUser.full_name,
        };

        let res = null;
        if (this.idOcorrencia > 0) {
          ocorrencia["id"] = this.idOcorrencia;
          res = await retencaoFinanceiraStore.updateRetencaoFinanceiraCobranca(
            ocorrencia
          );
        } else {
          res = await retencaoFinanceiraStore.createRetencaoFinanceiraCobranca(
            ocorrencia
          );
        }
        if (res) {
          this.$swal.fire("Cobrança", "Salva com sucesso!", "success");
          this.descricao = "";
          this.tipoContato = "";
          this.etapaCobranca = "";
          this.selectedTitulos = [];
          this.motivoNaoPagamento = [];
          this.acaoExecutada = [];
          this.dataProximaCobranca = "";
          this.objetivoCobranca = "";
          this.proximoStatus = 0;

          this.idOcorrencia = 0;
          this.$emit("getPropState", Math.floor(Math.random() * 200));
        } else {
          this.$swal.fire(
            "Falha ao salvar a cobrança.",
            "Tente novamente mais tarde!",
            "error"
          );
        }
        this.ocorrenciaItems = await retencaoFinanceiraStore.getRetencaoFinanceiraCobranca(
          this.propRetencaoItem.c014_id
        );
      }
      this.isSubmit = false;
    });
  }

  public async handleDeleteOcorrencia(id: number) {
    this.$swal({
      title: "Confirma a exclusão da cobrança?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, eu confirmo!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.ocorrencia_files = await retencaoFinanceiraStore.getFilesRetencaoFinanceiraCobranca(
          {
            table_name:
              String(this.propRetencaoItem.c014_id) + "retencao_financeira",
            id: String(id),
          }
        );

        if (this.ocorrencia_files.length > 0) {
          this.$swal.fire(
            "Existem arquivos em anexo a esta cobrança!",
            "Exclua os arquivos para depois excluir a cobrança...",
            "error"
          );
        } else {
          let res = await retencaoFinanceiraStore.deleteRetencaoFinanceiraCobranca(
            id
          );

          if (res == true) {
            this.$swal.fire("Cobrança", "Excluída com sucesso!", "success");
            this.$emit("getPropState", Math.floor(Math.random() * 200));
          } else {
            this.$swal.fire(
              "Falha ao excluir a cobrança.",
              "Tente novamente mais tarde!",
              "error"
            );
          }
        }
        this.ocorrenciaItems = await retencaoFinanceiraStore.getRetencaoFinanceiraCobranca(
          this.propRetencaoItem.c014_id
        );
      }
    });
  }

  public async handleEditarOcorrencia(item) {
    this.$swal({
      title: "Confirma a alteração da cobrança?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, eu confirmo!",
    }).then(async (result) => {
      this.isSubmit = true;
      if (result.isConfirmed) {
        this.descricao = item.descricao;

        let aux_t014 = item.t014_id_parcela.split(",");
        let arrayDeInteiros = aux_t014.map(function (elemento) {
          return parseInt(elemento, 10); // 10 indica a base numérica (decimal)
        });

        const estaVazio = arrayDeInteiros.some((item) => isNaN(Number(item)));
        if (!estaVazio && arrayDeInteiros.length > 0) {
          this.selectedTitulos = arrayDeInteiros;
        }

        this.tipoContato = item.tipo_contato;
        this.motivoNaoPagamento = item.motivo_nao_pagamento.split(",");
        this.etapaCobranca = item.etapa_cobranca;
        let aux = item.acao_executada.split(",");
        this.acaoExecutada = aux;
        this.dataProximaCobranca = item.proximo_contato;
        this.objetivoCobranca = item.objetivo;
        this.proximoStatus = item.status;
        this.idOcorrencia = item.id;
      }
      this.isSubmit = false;
    });
  }

  public async load() {
    if (!this.userProfile) return;

    if (this.propRetencaoItem.c014_id) {
      await cobrancaStore.getCobrancaDetails(this.propRetencaoItem.c014_id);
    } else {
      const c014_id = this.userProfile.company.c014_id;

      await cobrancaStore.getCobrancaDetails(c014_id);
    }
  }

  public getTituloSerasaPago() {
    let item = this.titulosSerasa[1];
    //@ts-ignore
    item = item.filter((f) => f.titulo === this.tituloSerasaPago);

    if (item[0]) {
      //@ts-ignore
      return item[0].status_titulo;
    } else {
      return [];
    }
  }

  public getTituloJudicialPago() {
    let item = this.titulosCobrancaJudicial[1];
    //@ts-ignore
    item = item.filter((f) => f.titulo === this.tituloJudicialPago);

    if (item[0]) {
      //@ts-ignore
      return item[0].status_titulo;
    } else {
      return [];
    }
  }

  public async mounted() {
    this.isLoading = true;

    await mainStore.userProfile;
    await userActionStore.getUserActions();

    if (this.propTipoTitulo) {
      this.tiposTitulo = this.propTipoTitulo;
    }

    await this.load();

    if (this.propRetencaoItem.c014_id > 0) {
      this.unidadeDetails = await companyStore.getCompanyByC014_id(
        String(this.propRetencaoItem.c014_id)
      );
    }

    this.titulosSerasa = await juridicoStore.getTitulosSerasa(
      this.propRetencaoItem.c014_id
    );
    this.titulosCobrancaJudicial = await juridicoStore.getTitulosCobranca(
      this.propRetencaoItem.c014_id
    );

    this.buscaTituloItems();

    this.ocorrenciaItems = await retencaoFinanceiraStore.getRetencaoFinanceiraCobranca(
      this.propRetencaoItem.c014_id
    );

    this.isLoading = false;
  }
}
